import { Component, HostListener } from "@angular/core";
import { Event, Router, NavigationStart, NavigationEnd } from "@angular/router";
import { PlatformLocation } from "@angular/common";
import { AuthService } from "./core/service/auth.service";
import Swal from "sweetalert2";
import { AuthTabSyncService } from "./core/service/auth-tab-sync.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  private startTime: number = 0;
  currentUrl: string;
  milliSecondsTime = 100000;
  counterRest: any;
  TimeOutTimerValue: any = 900000;  
  startLogoutTimevalue: any = 100000; 
  mainLogout_Thread: any;
  TimeOut_Thread: any;
  counter = 0;
  constructor(public _router: Router, location: PlatformLocation, private authService: AuthService, private router: Router,
     private authTabSyncService: AuthTabSyncService,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.startTime = performance.now(); 
      }
      if (event instanceof NavigationEnd) {
        const loadTime = performance.now() - this.startTime; 
        console.log(`🗹 sidebar component load time: ${loadTime.toFixed(2)} ms`);
      }
    });
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        // location.onPopState(() => {
        //   window.location.reload();
        // });
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
      }
      window.scrollTo(0, 0);
    });
    if (this.router.url != "/") {
      if(this.router.url !== '/authentication/signin') {
      console.log(this.router.url);
      this.TimeOut_Thread = setTimeout(() => {
        this.LogoutByTimer();
      }, this.TimeOutTimerValue);
    }
    }


  }
  @HostListener('window:beforeunload', ['$event'])
  async onBeforeUnload(event) {
    event.preventDefault(); // prevent the default behavior
    event.returnValue = true;
    // setTimeout(this.onPageUnload.bind(event), 0);
    this.authService.logintracker({ "loginTrackId": localStorage.getItem('loginTrackId'), "btn_name": "LOGOUT" }).subscribe((response) => {
    });
    
  }
  @HostListener('keydown', ['$event'])
  @HostListener('keyup', ['$event'])
  @HostListener('click', ['$event'])
  @HostListener('mousemove', ['$event'])
  @HostListener('DOMMouseScroll', ['$event'])
  @HostListener('mousewheel', ['$event'])
  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  @HostListener('touchmove', ['$event'])
  @HostListener('scroll', ['$event'])
  @HostListener('focus', ['$event'])
  onAnyEvent(event: Event) {
    if (this.router.url !== '/authentication/signin') {
      this.resetTimer();
    }

  }


  resetTimer() {
    this.TimeOut_Resetter();
    this.resetMainLogut();
    this.clearInterval();
    setTimeout(() => {
      this.milliSecondsTime = 10000;
    }, 100);
  }


  LogoutByTimer() {
    Swal.fire({
      title: 'Your going to be logout after 10 sec.',
      showCancelButton: true,
      allowEscapeKey: true,
      cancelButtonColor: "red",
      showConfirmButton: false,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
        this.resetTimer();
      }

    });
    // Swal.showLoading();
    this.mainLogout_Thread = setTimeout(() => {
      // console.log("logout service call");
      this.authService.logintracker({ "loginTrackId": localStorage.getItem('loginTrackId'), "btn_name": "LOGOUT" }).subscribe((response) => {
      });
      this.authService.logout().subscribe((res) => {
        if (!res.success) {
          this.router.navigate(["/authentication/signin"]);
        }
      });
    }, this.startLogoutTimevalue);

    this.counterRest = setInterval(() => {
      this.milliSecondsTime = this.milliSecondsTime - 1000;
      if (this.milliSecondsTime / 1000 == 0) {
        this.clearInterval();
        this.counter = 0;
        Swal.getTitle().textContent = `Your going to be logout after ${this.counter} sec.`
        // Swal.hideLoading();
        Swal.close();
      } else {
        // Swal.showLoading();
        this.counter = this.milliSecondsTime / 1000;
        Swal.getTitle().textContent = `Your going to be logout after ${this.counter} sec.`
      }
    }, 1000);
    console.log(this.counter);
  }

  resetMainLogut() {
    // console.log("clear logout");
    clearTimeout(this.mainLogout_Thread);
  }

  clearInterval() {
    clearTimeout(this.counterRest);
  }

  TimeOut_Resetter() {
    clearTimeout(this.TimeOut_Thread);
    this.TimeOut_Thread = setTimeout(() => {
      this.LogoutByTimer();
    }, this.TimeOutTimerValue);
  }




  onPageUnload(event) {
    if (typeof event === 'undefined') {
      console.log('User clicked the Cancel button');
    } else {
      localStorage.setItem("leave", 'true');
    }
  }

  // @HostListener('document:contextmenu', ['$event'])
  // onRightClick(event: MouseEvent): void {
  //   event.preventDefault();
  // }
  // @HostListener('document:keydown', ['$event'])
  // onKeyPress(event: KeyboardEvent): void {
  //   if (event.ctrlKey && event.shiftKey && event.key === 'I') {
  //     event.preventDefault();
  //   }
  // }
}
